<template>
    <b-table class="list-table" :items="data" :fields="fields" responsive="">
        <template v-slot:cell(date)="data">
            {{moment.unix(data.item.date).format("MMM D Y")}}
        </template>
        <template v-slot:cell(salesRep)="data">
            <a :href="$laravelRoute('users.show', data.item.salesRepId)" style="cursor:pointer;color:blue;text-decoration:underline;">
                {{ data.item.salesRep }}</a>
        </template>
        <template v-slot:cell(views)="data">
            <a v-if="data.item.views > 0" :href="viewsLink(data)" class="link">
                {{ data.item.views }}
            </a>
            <template v-else>{{ data.item.views }}</template>
        </template>
        <template v-slot:cell(bids)="data">
            <a v-if="data.item.bids > 0" :href="bidLink(data)" class="link">
                {{ data.item.bids }}
            </a>
            <template v-else>{{ data.item.bids }}</template>
        </template>
    </b-table>
</template>

<script>

    export default {
        props: [
            'result',
            'userid'
        ],
        data() {
            return {
                data: this.result,
                fields: [
                    {
                        key: 'date',
                        sortable: true,
                    },
                    {
                        key: 'company',
                        label: 'Company',
                    },
                    {
                        key: 'views',
                        label: 'Number Of Cars Viewed',
                        sortable: true,
                    },
                    {
                        key: 'bids',
                        label: 'Number Of Bids',
                        sortable: true,
                    },
                    {
                        key: 'salesRep',
                        label: 'Rep of customer',
                        sortable: true,
                    },
                ],
                moment: window.moment
            }
        },
        methods: {

            bidLink(data){
                const date = this.moment.unix(data.item.date).format("YYYY-MM-DD");
                return `/user-bid?filter_user_ids=${this.userid}&filter_by_date=${date}`
            },
            viewsLink(data){
                const date = this.moment.unix(data.item.date).format("YYYY-MM-DD");
                return `/vehicle-view?user_id=${this.userid}&filter_by_date=${date}`
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/History/HistoryByUser.vue